import { useState } from "react";

export const useDeleteUserStates = () => {
  const [check, setCheck] = useState(false);
  // 削除ボタン有効フラグ
  const [isActiveDeleteButton, setIsActiveDeleteButton] = useState(false);

  // 確認ダイアログ表示フラグ
  const [isShowConfirmDialog, setIsShowConfirmDialog] = useState(false);

  // エラーダイアログ表示フラグ情報
  const [isShowErrorDialog, setIsShowErrorDialog] = useState({
    isError: false,
    errorMessage: "",
  });

  return {
    check,
    setCheck,
    isActiveDeleteButton,
    setIsActiveDeleteButton,
    isShowConfirmDialog,
    setIsShowConfirmDialog,
    isShowErrorDialog,
    setIsShowErrorDialog,
  };
};
